import TextComponent from 'app_components/commons/TextComponent/TextComponent'
import { IFetchScheduling } from 'app_types/campus/academic/schedulingTypes'
import React, { FC } from 'react'
import LearningPathItem from '../LearningPathItem/LearningPathItem'
import LoadingWrapper from 'app_components/commons/LoadingWrapper/LoadingWrapper';

import './LearningPath.scss'

interface ILearningPathProps {
  learningWay?: IFetchScheduling
  loading?: boolean
}

const LearningPath: FC<ILearningPathProps> = ({ learningWay, loading }) => {
  return (
    <LoadingWrapper loading={!!loading}>
      {!!learningWay ? (
        <div className="learning-path--layout">
          <div>
            <TextComponent
              type='subtitle'
            >
              {/* @ts-ignore */}
              {learningWay?.program?.name}
            </TextComponent>
          </div>
          <div>
            {/* @ts-ignore */}
            {learningWay?.courses.map((item, index) => (
              <LearningPathItem
                key={`course_${index}`}
                item={{title: `#${index+1}`, content: item.course_name}}
              />
            ))}
          </div>
        </div>
      ) : <div></div>}
    </LoadingWrapper>
  )
}

export default LearningPath
